<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-dialog v-model="confirm" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Confirmation</v-card-title>
          <v-card-text>Do you want to resend this email?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat @click.native="confirm = false">No</v-btn>
            <v-btn color="green darken-1" flat @click.native="resend()">Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-flex xs12>
        <v-menu offset-y full-width>
         <v-text-field
          label="Search"
          prepend-icon="search"
          v-model="searchtext"
          @input="refreshData"
          slot="activator"
          single-line
         ></v-text-field>
          <v-list>
            <v-list-tile v-for="item in searchitem" :key="item.empId" @click="solveD(item)" >
              <v-list-tile-title>{{ item.name }} ( {{ item.nik }} )</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>
      <v-flex xs12>
        <v-flex xs12 v-for="item in data" :key="item.id">
          <v-card tile>
            <v-layout row align-center class="p-lt-10px">
              <v-flex xs7 md10 lg11>
                <h3>
                  {{item.title}}
                </h3>
                <p class="f-12px">
                  From User {{item.fromUser.name}} ( {{item.fromUser.nik}} ) | Level : {{item.level}}
                  | {{item.createdTime | moment('DD MMM YYYY HH:mm')}} | {{item.editable | uppercase()}}
                </p>
              </v-flex>
              <v-flex xs5 md2 lg1 class="text-xs-center">
                <v-btn small @click="openconfirm(item)" color="success">
                  <v-icon small class="mr-5px">email</v-icon>
                  Resend
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>
          <br>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import _ from 'lodash'
import Vuex from 'vuex'

const employeeStore = Vuex.createNamespacedHelpers('Employee')
const worklistStore = Vuex.createNamespacedHelpers('Worklist')

export default {
  name: 'business-trip-resendemail',
  components: {
  },
  data: () => ({
    title: 'Business Trip Resend Email',
    searchtext: '',
    confirm: false,
    sitem: {},
    searchitem: [],
    data: [],
    actions: []
  }),
  methods: {
    ...employeeStore.mapActions({
      searchEmployee: 'searchEmployee'
    }),
    ...worklistStore.mapActions({
      getApprovalByToUser: 'getApprovalByToUser',
      emailWorklistById: 'emailWorklistById'
    }),
    loadData (e) {
      if (this.searchtext !== '') {
        this.searchEmployee({vueinstance: this, key: this.searchtext})
          .then(res => { this.searchitem = res })
          .catch(err => { this.$error(err) })
      }
    },
    refreshData: _.debounce(function () { this.loadData() }, 500),
    solveD (value) {
      this.searchtext = value.name
      this.getApprovalByToUser({vueinstance: this, empid: value.empId})
        .then(res => { this.data = res })
        .catch(err => { this.$error(err) })
    },
    openconfirm (value) {
      this.sitem = value
      this.confirm = true
    },
    resend () {
      let value = this.sitem
      this.emailWorklistById({vueinstance: this, id: value.id, obj: {}})
        .then(res => {
          this.$success('Resend Success')
          this.confirm = false
        })
        .catch(err => {
          this.$error(err)
          this.confirm = false
        })
    }
  },
  mounted () {
    this.$store.dispatch('setTitle', {title: this.title})
    this.$store.dispatch('Action/setActions', [])
  }
}
</script>

<style scoped>
.p-lt-10px{
  padding: 15px 15px 0px 15px
}
.mr-5px{
  margin-right: 5px
}
.f-12px{
  font-size: 12px
}
</style>



// WEBPACK FOOTER //
// src/components/bt-resendemail/BT-ResendEmail.vue